import React, { useState, useEffect } from "react";
import { Pencil, Trash2, Star } from "lucide-react";
import { toast } from "react-toastify";
import axios from "axios";

export const AddressesPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    id: null,
    fullName: "",
    phone: "",
    address: "",
    isDefault: false,
  });
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("add");

  useEffect(() => {
    const userAddresses = JSON.parse(
      localStorage.getItem("userAddresses") || "[]",
    );
    if (userAddresses) {
      try {
        setAddresses(userAddresses);
      } catch {
        setAddresses([]);
      }
    }
  }, []);

  // Thêm/Cập nhật địa chỉ
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (mode === "add") {
      const payload = {
        name: form.fullName,
        phone: form.phone,
        address: form.address,
        isDefault: form.isDefault,
      };

      axios
        .post("/user/address/create", payload)
        .then((res) => {
          // Giả sử server trả về object địa chỉ đã tạo (có id)
          const created = res.data;
          setAddresses((prev) => {
            let arr = prev;
            if (form.isDefault) {
              arr = prev.map((addr) => ({ ...addr, isDefault: false }));
            }
            return [{ ...created }, ...arr];
          });
          setForm({
            id: null,
            fullName: "",
            phone: "",
            address: "",
            isDefault: false,
          });
          setShowModal(false);
          setLoading(false);
          setMode("add");
        })
        .catch((err) => {
          console.error(err);
          toast.error("Có lỗi xảy ra. Vui lòng thử lại sau!");
          setLoading(false);
        });
    } else if (mode === "edit") {
      setTimeout(() => {
        setAddresses((prev) => {
          let arr = prev;
          if (form.isDefault) {
            arr = prev.map((addr) => ({ ...addr, isDefault: false }));
            console.log(arr);
          }
          return prev.map((addr) =>
            addr.id === form.id
              ? {
                  ...addr,
                  fullName: form.fullName,
                  phone: form.phone,
                  address: form.address,
                  isDefault: form.isDefault,
                }
              : addr,
          );
        });
        setForm({
          id: null,
          fullName: "",
          phone: "",
          address: "",
          isDefault: false,
        });
        setShowModal(false);
        setLoading(false);
        setMode("add");
      }, 400);
    }
  };

  // Xoá địa chỉ
  const handleRemove = (id) => {
    setAddresses((prev) => prev.filter((a) => a.id !== id));
  };

  // Chỉ cho phép nhập số ở input SĐT
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone") {
      const onlyNums = value.replace(/\D/g, "");
      setForm((prev) => ({
        ...prev,
        [name]: onlyNums,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  // Chặn ký tự không phải số khi nhập ở ô phone
  const handlePhoneKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  // Đảm bảo dán clipboard vào phone cũng chỉ cho số
  const handlePhonePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").replace(/\D/g, "");
    setForm((prev) => ({
      ...prev,
      phone: (prev.phone || "") + paste,
    }));
  };

  // Đặt làm mặc định (callback trống)
  const handleSetDefault = () => {
    // TODO: Viết logic đặt mặc định nếu cần
  };

  // Mở modal cập nhật, set mode "edit" và fill form
  const handleEdit = (item) => {
    setMode("edit");
    setForm({
      id: item.id,
      fullName: item.fullName || item.name || "",
      phone: item.phone || "",
      address: item.address || "",
      isDefault: !!item.isDefault,
    });
    setShowModal(true);
  };

  // Mở modal thêm mới
  const handleOpenAdd = () => {
    setMode("add");
    setForm({
      id: null,
      fullName: "",
      phone: "",
      address: "",
      isDefault: false,
    });
    setShowModal(true);
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <a className="breadcrumb-item text-dark" href="#">
                Trang chủ
              </a>
              <span className="breadcrumb-item active">Địa chỉ đặt hàng</span>
            </nav>
          </div>
        </div>
      </div>

      {/* Nền trắng cho phần nội dung */}
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <div className="bg-white rounded p-4 mb-5 min-h-[12rem]">
              {/* Nút thêm địa chỉ */}
              <div className="d-flex justify-content-end mb-3 mr-3">
                <button
                  className="btn btn-primary d-flex align-items-center"
                  style={{ fontWeight: 500 }}
                  onClick={handleOpenAdd}
                >
                  <span
                    className="mr-2"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      fontSize: 17,
                    }}
                  >
                    <i className="fa fa-plus"></i>
                  </span>
                  Thêm địa chỉ
                </button>
              </div>

              {/* Khi chưa có địa chỉ */}
              {addresses.length === 0 && (
                <div className="d-flex flex-column align-items-center">
                  <div style={{ marginTop: 15, color: "#555", fontSize: 16 }}>
                    Bạn chưa có địa chỉ nào
                  </div>
                </div>
              )}

              {/* Danh sách địa chỉ dạng block/card */}
              {addresses.length > 0 && (
                <div className="mt-4">
                  {addresses.length > 0 && (
                    <div className="mt-4 mx-3">
                      {addresses.map((item, idx) => (
                        <div
                          key={item.id || idx}
                          className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border border-gray-200 rounded-2xl bg-white shadow-sm md:p-10 p-4 mb-4 transition hover:shadow-md"
                        >
                          {/* Thông tin địa chỉ */}
                          <div className="flex-1 min-w-0 w-full">
                            {/* Hàng tên + nút mặc định (desktop) */}
                            <div className="flex items-center gap-2 mb-1">
                              <span className="font-semibold text-lg text-gray-900 truncate">
                                {item.fullName || item.name}
                              </span>
                              {item.isDefault ? (
                                <span className="hidden md:inline-flex items-center gap-1 px-2 py-2 rounded-lg text-xs font-medium bg-blue-50 text-blue-700 ml-2">
                                  <Star className="w-4 h-4" /> Mặc định
                                </span>
                              ) : (
                                <button
                                  className="hidden md:inline-flex ml-2 px-2 py-2 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-600 hover:text-white text-xs font-semibold transition"
                                  onClick={() => handleSetDefault(item.id)}
                                  tabIndex={-1}
                                >
                                  Đặt làm mặc định
                                </button>
                              )}
                            </div>
                            {/* Số điện thoại */}
                            <div className="flex items-center gap-4 flex-wrap text-gray-700 mb-1">
                              <span className="font-medium">{item.phone}</span>
                            </div>
                            {/* Địa chỉ */}
                            <div className="text-gray-500 text-sm break-words">
                              {item.address}
                            </div>
                            {/* Nút mặc định (mobile) */}
                            <div className="block md:hidden mt-2">
                              {item.isDefault ? (
                                <span className="inline-flex items-center gap-1 px-2 py-2 rounded-lg font-medium bg-blue-50 text-sm text-blue-700">
                                  <Star className="w-4 h-4" /> Mặc định
                                </span>
                              ) : (
                                <button
                                  className="px-2 py-2 rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-600 hover:text-white text-sm font-semibold transition"
                                  onClick={() => handleSetDefault(item.id)}
                                  tabIndex={-1}
                                >
                                  Đặt làm mặc định
                                </button>
                              )}
                            </div>
                          </div>
                          {/* Action buttons */}
                          <div className="flex gap-2 md:gap-3 items-center self-end md:self-auto">
                            <button
                              className="flex items-center focus:outline-none focus:ring-0 active:outline-none gap-1 px-3 py-1 rounded-xl text-blue-700 hover:text-white bg-blue-50 hover:bg-blue-600 text-sm font-medium transition"
                              onClick={() => handleEdit(item)}
                              title="Cập nhật"
                            >
                              <Pencil className="w-4 h-4" /> Cập nhật
                            </button>
                            <button
                              className="flex items-center focus:outline-none focus:ring-0 active:outline-none gap-1 px-3 py-1 rounded-xl text-red-600 hover:text-white bg-red-50 hover:bg-red-600 text-sm font-medium transition"
                              onClick={() => handleRemove(item.id)}
                              title="Xóa"
                            >
                              <Trash2 className="w-4 h-4" /> Xóa
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Modal thêm/cập nhật địa chỉ */}
              {showModal && (
                <ModalAddAddress
                  form={form}
                  onChange={handleChange}
                  onPhoneKeyPress={handlePhoneKeyPress}
                  onPhonePaste={handlePhonePaste}
                  onSubmit={handleSubmit}
                  onClose={() => {
                    setShowModal(false);
                    setMode("add");
                    setForm({
                      id: null,
                      fullName: "",
                      phone: "",
                      address: "",
                      isDefault: false,
                    });
                  }}
                  loading={loading}
                  mode={mode}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Modal nhập/cập nhật địa chỉ
function ModalAddAddress({
  form,
  onChange,
  onPhoneKeyPress,
  onPhonePaste,
  onSubmit,
  onClose,
  loading,
  mode,
}) {
  const [errors, setErrors] = useState({});

  // Hàm kiểm tra hợp lệ
  const validate = () => {
    const newErrors = {};

    // Họ tên: trên 5 ký tự
    if (!form.fullName || form.fullName.trim().length < 5) {
      newErrors.fullName = "Họ và tên phải có ít nhất 5 ký tự.";
    }

    // Số điện thoại VN: 10 số, bắt đầu bằng 0, hoặc +84...
    if (!form.phone || !/^(0\d{9}|(\+84)\d{9,10})$/.test(form.phone.trim())) {
      newErrors.phone = "Số điện thoại không hợp lệ.";
    }

    // Địa chỉ: tối thiểu 5 ký tự, không để trống
    if (!form.address || form.address.trim().length < 5) {
      newErrors.address = "Địa chỉ phải tối thiểu 5 ký tự.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Bọc lại handle submit để validate
  const handleLocalSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(e);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
      aria-modal="true"
      role="dialog"
    >
      <div className="bg-white rounded shadow-xl w-full max-w-md mx-4 animate-fade-in">
        <form onSubmit={handleLocalSubmit} className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-800">
              {mode === "edit" ? "Cập nhật địa chỉ" : "Thêm địa chỉ mới"}
            </h3>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-red-500 text-2xl font-bold rounded focus:outline-none"
              aria-label="Đóng"
            >
              &times;
            </button>
          </div>
          <div className="space-y-4">
            <div>
              <label
                htmlFor="fullName"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Họ và tên
              </label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={form.fullName}
                onChange={onChange}
                className={`w-full px-3 py-2 border ${
                  errors.fullName ? "border-red-400" : "border-gray-300"
                } rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-base`}
                autoComplete="off"
              />
              {errors.fullName && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.fullName}
                </div>
              )}
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Số điện thoại
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                value={form.phone}
                onChange={onChange}
                onKeyPress={onPhoneKeyPress}
                onPaste={onPhonePaste}
                className={`w-full px-3 py-2 border ${
                  errors.phone ? "border-red-400" : "border-gray-300"
                } rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-base`}
                autoComplete="off"
                inputMode="numeric"
                pattern="[0-9]*"
              />
              {errors.phone && (
                <div className="text-red-500 text-xs mt-1">{errors.phone}</div>
              )}
            </div>
            <div>
              <label
                htmlFor="address"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Địa chỉ
              </label>
              <input
                type="text"
                id="address"
                name="address"
                value={form.address}
                onChange={onChange}
                className={`w-full px-3 py-2 border ${
                  errors.address ? "border-red-400" : "border-gray-300"
                } rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-base`}
                autoComplete="off"
              />
              {errors.address && (
                <div className="text-red-500 text-xs mt-1">
                  {errors.address}
                </div>
              )}
            </div>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="isDefault"
                name="isDefault"
                checked={form.isDefault}
                onChange={onChange}
                className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <label
                htmlFor="isDefault"
                className="text-sm text-gray-700 select-none m-0 !ml-2"
              >
                Đặt làm địa chỉ mặc định
              </label>
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-1 hover:bg-gray-200 text-gray-800 font-medium rounded border border-gray-300 transition"
            >
              Đóng
            </button>
            <button
              type="submit"
              className="px-4 py-1 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded transition disabled:opacity-70"
              disabled={loading}
            >
              {loading
                ? mode === "edit"
                  ? "Đang cập nhật..."
                  : "Đang lưu..."
                : mode === "edit"
                  ? "Cập nhật"
                  : "Lưu"}
            </button>
          </div>
        </form>
      </div>
      {/* Animation style */}
      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.22s;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(30px) scale(.98);}
          to { opacity: 1; transform: translateY(0) scale(1);}
        }
      `}</style>
    </div>
  );
}
